import { FormattedMessage } from 'react-intl';

import { BooleanPropertyToggle } from '../boolean-property-toggle';
import { messages } from './messages';

import type { TextWidget, WidgetPropertyDefinition, WidgetPropertyInput } from '../../../config';

const IsBold = ({ widget, updateWidget, ...rest }: WidgetPropertyInput<TextWidget>) => {
  return <BooleanPropertyToggle updateWidget={(value) => updateWidget({ isBold: value })} value={widget.isBold} {...rest} />;
};

export const IsBoldProperty: WidgetPropertyDefinition<TextWidget> = {
  id: 'is-bold',
  label: <FormattedMessage {...messages.label} />,
  Component: IsBold,
};
